<template>
  <div style="width: 99%">
    <div class="inputs-container">
      <div class="page-filters__right-wrapper">
        <div class="page-filters__right-title-wrapper">
          <div class="products-page__datetime-title">Data Inicial</div>
        </div>
        <div class="page-filters__right-select-wrapper">
          <datetime
            value-zone="UTC-3"
            class="datetime-input form-control"
            v-model="fromDate"
            ref="datepicker"
            auto
            type="date"
            :max-datetime="toDate"
          ></datetime>
          <span class="material-icons date-icon"> search </span>
        </div>
      </div>
      <div class="page-filters__right-wrapper">
        <div class="page-filters__right-title-wrapper">
          <div class="products-page__datetime-title">Data Final</div>
        </div>
        <div class="page-filters__right-select-wrapper">
          <datetime
            value-zone="UTC-3"
            class="datetime-input form-control"
            v-model="toDate"
            ref="datepicker"
            auto
            type="date"
            :min-datetime="fromDate"
          ></datetime>
          <span class="material-icons date-icon"> search </span>
        </div>
      </div>
      <StandardButton
        class="margin-button"
        :action="() => getExcel()"
        iconName="file_download"
        :text="'Exportar Excel'"
      />
      <StandardButton
        style="margin-left: 2%"
        :action="() => updatePage(1)"
        iconName="search"
        :text="'Filtrar'"
      />
    </div>

    <div class="page-table-header">
      <div class="page-table-header-text name-width" style="text-align: start">Nome</div>
      <div class="page-table-header-text info-width">Valor mínimo</div>
      <div class="page-table-header-text info-width">Valor Médio</div>
      <div class="page-table-header-text info-width">Valor Máximo</div>
      <div class="page-table-header-text info-width">Quantidade Digitação</div>
    </div>
    <div v-for="p in products" :key="p.prod_id" style="margin-bottom: 1.5vw">
      <div class="page-table-row">
        <div
          class="page-table-code-colum name-width"
          style="justify-content: start; font-weight: bold"
        >
          <span
            v-if="p.brands.length == 0"
            @click="
              () => {
                showProductHistory = p;
              }
            "
            class="material-icons-outlined"
            style="cursor: pointer; font-size: 1.5em; margin-right: 1vw; color: gray"
            >description</span
          >
          {{ p.pro_descricao }}
        </div>
        <div class="page-table-code-colum info-width">
          <span class="min-color">R$ {{ p.min_valor.toFixed(2) }}</span>
        </div>
        <div class="page-table-code-colum info-width">
          <span class="med-color">R$ {{ p.avg_valor.toFixed(2) }}</span>
        </div>
        <div class="page-table-code-colum info-width">
          <span class="max-color">R$ {{ p.max_valor.toFixed(2) }}</span>
        </div>
        <div
          class="page-table-code-colum info-width"
          style="font-weight: bold; border-right: none"
        >
          {{ p.total }}
        </div>
      </div>
      <div
        v-for="(b, idx) in p.brands"
        :key="b.propd_id"
        class="page-table-row"
        :class="{ 'page-table-line-special': idx % 2 == 0 }"
      >
        <div
          class="page-table-code-colum name-width"
          style="padding-left: 5%; justify-content: start"
        >
          <span
            @click="
              () => {
                showProductHistory = p;
                brand = b;
              }
            "
            class="material-icons-outlined"
            style="cursor: pointer; font-size: 1.5em; margin-right: 1vw; color: gray"
            >description</span
          >
          {{ b.pro_observacao }}
        </div>
        <div class="page-table-code-colum info-width">
          R$ {{ b.min_valor.toFixed(2) }}
        </div>
        <div class="page-table-code-colum info-width">
          R$ {{ b.avg_valor.toFixed(2) }}
        </div>
        <div class="page-table-code-colum info-width">
          R$ {{ b.max_valor.toFixed(2) }}
        </div>
        <div class="page-table-code-colum info-width" style="border-right: none">
          {{ b.offers }}
        </div>
      </div>
    </div>
    <Paginacao
      classes="orange justify-end"
      :items_by_page_value="10"
      :total="totalItems"
      :page="1"
      v-on:change="updatePage($event)"
    ></Paginacao>
    <cc-loader-full v-if="isLoading" />
    <ProductHistory
      v-if="showProductHistory"
      :product="showProductHistory"
      :propFromDate="fromDate"
      :propToDate="toDate"
      :brand="brand"
      :close="() => (showProductHistory = false)"
    />
    <a id="download-excel" style="display: none"></a>
  </div>
</template>

<script>
import moment from "moment";
import ClientService from "../../services/v3/ClientService";
import Paginacao from "@/components/cliente/base-components/Pagination";
import StandardButton from "@/components/ui/buttons/Standard-Button.vue";
import ProductHistory from "./ProductHistory.vue";

export default {
  name: "CotProducts",
  data() {
    return {
      service: new ClientService(),
      isLoading: true,
      products: [],
      totalItems: 0,
      fromDate: moment().add(-30, "days").toISOString(),
      toDate: moment().toISOString(),
      showProductHistory: false,
      brand: undefined,
    };
  },
  components: {
    Paginacao,
    StandardButton,
    ProductHistory,
  },
  created() {
    this.loadPage(1);
  },
  methods: {
    loadPage(page) {
      const from = this.fromDate.split("T")[0];
      const to = this.toDate.split("T")[0] + "T23:59:59";
      this.service.getproducts(page, from, to).then((resp) => {
        this.products = resp.data.data;
        this.products.forEach((element) => {
          if (element.brands.length > 0) {
            element.total = element.brands.reduce(
              (partialSum, a) => partialSum + a.offers,
              0
            );
            element.brands.sort((a, b) =>
              a.pro_observacao.localeCompare(b.pro_observacao)
            );
            let min = element.brands[0].min_valor;
            let max = element.brands[0].max_valor;
            element.brands.forEach((v) => {
              if (v.min_valor < min) min = v.min_valor;
            });
            element.brands.forEach((v) => {
              if (v.max_valor > max) max = v.max_valor;
            });
            let med =
              element.brands.reduce((partialSum, a) => partialSum + a.avg_valor, 0) /
              element.brands.length;
            element.avg_valor = med;
            element.min_valor = min;
            element.max_valor = max;
          } else element.total = element.offers;
        });
        this.totalItems = resp.data.total;
        this.isLoading = false;
      });
    },
    updatePage(page) {
      this.isLoading = true;
      this.loadPage(page);
    },
    getExcel() {
      this.isLoading = true;
      this.service
        .getproducts(1, this.fromDate.split("T")[0], this.toDate.split("T")[0], true)
        .then((resp) => {
          if (resp.data instanceof Blob) {
            this.downloadFile(resp.data, "acompanhamentoDePreco.xls");
          } else {
            var file = new Blob([resp.data], { type: "application/vnd.ms-excel" });
            this.downloadFile(file, "AcompanhamentoDePreco.xls");
          }
        })
        .catch((error) => {
          console.error("Error downloading Excel file:", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    downloadFile(file, filename) {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      if (isIOS) {
        const reader = new FileReader();
        reader.onload = () => {
          const link = document.createElement("a");
          link.href = reader.result;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        };
        reader.readAsDataURL(file);
      } else {
        const url = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-table-header {
  background: #fffefc;
  border: 0.5px solid #e5e5e5;
  display: flex;
  padding: 0.5vw 1vw;
  margin-bottom: 1vw;
}

.page-table-header-text {
  font-size:0.8em;
  color: #605f5f;
  text-align: center;
}

.page-table-line-special {
  background: #f7f7f7;
}

.info-width {
  width: 15%;
}

.page-table-code-colum {
  padding-left: 10px;
  border-right: 1px solid #dde5e9;
  display: flex;
  justify-content: center;
}

.page-table-row {
  display: flex;
  font-weight: 300;
  font-size: 0.8rem;
  color: #605f5f;
  padding: 0.2vw 0.5vw;
}

.max-color {
  background-color: rgb(247, 219, 219);
  color: #cd2a2a;
  border-radius: 8px;
  text-align: center;
  width: 60%;
}
.min-color {
  background-color: rgb(218, 244, 218);
  color: #30aa4c;
  border-radius: 8px;
  text-align: center;
  width: 60%;
}

.med-color {
  background-color: #17a2b81a;
  color: #17a2b8;
  border-radius: 8px;
  text-align: center;
  width: 60%;
}

.page-filters__right-title-wrapper {
  display: flex;
  align-items: center;
}

.products-page__datetime-title {
  font-size: 1.7em;
  font-weight: 400;
  letter-spacing: 0.15px;
  color: #898989;
}

.page-filters__right-select-wrapper {
  display: flex;
  align-items: center;
}

.date-icon {
  background-color: var(--primary-color);
  color: #fff;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 0px 8px 8px 0px;
  position: relative;
  left: -6px;
}

.datetime-input {
  border-radius: 8px !important;
}

.inputs-container {
  display: flex;
  gap: 2vw;
  margin-bottom: 3vh;
  align-items: end;
}

.margin-button {
  margin-left: auto;
}

@media only screen and (max-width: 600px) {
  .inputs-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .margin-button {
    margin-left: 0;
  }

  .page-table-header-text {
    padding-left: 0;
  }
}
</style>
